/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashbackRatesContainer_brand$ref = any;
export type CashbackRatesContainerQueryVariables = {|
  storeIdEq: string,
  afterDate: any,
  beforeDate: any,
|};
export type CashbackRatesContainerQueryResponse = {|
  +brand: ?{|
    +$fragmentRefs: CashbackRatesContainer_brand$ref
  |}
|};
export type CashbackRatesContainerQuery = {|
  variables: CashbackRatesContainerQueryVariables,
  response: CashbackRatesContainerQueryResponse,
|};
*/


/*
query CashbackRatesContainerQuery(
  $storeIdEq: ID!
  $afterDate: Date!
  $beforeDate: Date!
) {
  brand: store(id: $storeIdEq) {
    ...CashbackRatesContainer_brand
    id
  }
}

fragment CashbackRatesContainer_brand on Store {
  id
  name
  defaultCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {
    startDate
    endDate
    rate
    state
  }
  birthdayCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {
    startDate
    endDate
    rate
    state
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIdEq",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDate",
    "type": "Date!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "beforeDate",
    "type": "Date!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeIdEq"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "afterDate",
    "variableName": "afterDate"
  },
  {
    "kind": "Variable",
    "name": "beforeDate",
    "variableName": "beforeDate"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "endDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CashbackRatesContainerQuery",
    "selections": [
      {
        "alias": "brand",
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CashbackRatesContainer_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CashbackRatesContainerQuery",
    "selections": [
      {
        "alias": "brand",
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "CashbackRate",
            "kind": "LinkedField",
            "name": "defaultCashbackRates",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "CashbackRate",
            "kind": "LinkedField",
            "name": "birthdayCashbackRates",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CashbackRatesContainerQuery",
    "operationKind": "query",
    "text": "query CashbackRatesContainerQuery(\n  $storeIdEq: ID!\n  $afterDate: Date!\n  $beforeDate: Date!\n) {\n  brand: store(id: $storeIdEq) {\n    ...CashbackRatesContainer_brand\n    id\n  }\n}\n\nfragment CashbackRatesContainer_brand on Store {\n  id\n  name\n  defaultCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {\n    startDate\n    endDate\n    rate\n    state\n  }\n  birthdayCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {\n    startDate\n    endDate\n    rate\n    state\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4bf6ba4fe81e6c9d482c8c2afe801a93';

module.exports = node;
